module.exports = __webpack_public_path__ + "assets/images/kriti_tv.1d55dff1d6e2bca41c545388cb8edd65.png";